<template>
    <div>
        <v-expansion-panels v-model="panel" mandatory>

            <div class="w-100">
                <v-alert type="info" text class="" border="right" colored-border v-if="isRevival">
                    La relance inclus les prestataires qui n'ont pas répondu lors de l'envoi précédent.<br>

                    Les formulaires en brouillon ne sont pas inclus dans la relance. Les prestataires sont relancés
                    automatiquement 3 et 7 jours après la date du brouillon.
                </v-alert>

                <v-alert type="info" text class="mb-5" v-if="emailsWrong.length">
                    Les prestataires sans destinataire valide ne seront pas inclus dans la campagne.
                </v-alert>
            </div>

          <v-expansion-panel v-if="alreadyInCampaign.length">
            <v-expansion-panel-header>
              <div class="table-title">
                <h3>
                    <span class="mr-3">Impliqués dans une campagne en cours</span>

                    <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                            <v-icon v-on="on">help</v-icon>
                        </template>
                        <div>
                            Ces prestataires sont déjà sollicités dans une autre campagne en cours.
                            En continuant ils seront aussi sollicités dans cette campagne.
                        </div>
                    </v-tooltip>

                    <div class="badge bg-warning text-white ml-3">{{ alreadyInCampaign.length }}</div>
                </h3>
              </div>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-simple-table class="border" fixed-header height="50vh">
                <thead>
                <tr>
                  <th class="text-left">Nom</th>
                  <th class="text-left">Catégorie</th>
                  <th class="text-left">Destinataire</th>
                  <th></th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="provider in alreadyInCampaign" :key="provider.id">
                  <td>{{ provider.name }}</td>
                  <td>{{ provider.category }}</td>
                  <td>
                    <span v-if="provider.email !== null">{{ provider.email }}</span>
                  </td>
                </tr>
                </tbody>
              </v-simple-table>
            </v-expansion-panel-content>
          </v-expansion-panel>

            <v-expansion-panel v-if="emailsWrong.length">
                <v-expansion-panel-header>
                    <div class="table-title">
                        <h3>E-mails non renseignés <div class="badge bg-warning text-white">{{
                                emailsWrong.length
                        }}</div>
                        </h3>
                    </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                    <v-simple-table class="border">
                        <thead>
                            <tr>
                                <th class="text-left">Nom</th>
                                <th class="text-left">Catégorie</th>
                                <th class="text-left">Erreur</th>
                                <th class="text-left">Destinataire</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="provider in emailsWrong" :key="provider.id">
                                <td>{{ provider.name }}</td>
                                <td>{{ provider.category }}</td>
                                <td>{{ provider.error }}</td>
                                <td>
                                    <span v-if="provider.email !== null">{{ provider.email }}</span>
                                </td>
                                <td>
                                    <v-tooltip bottom v-if="selectedApidaeSelection === null">
                                        <template v-slot:activator="{ on }">
                                            <v-btn v-on="on" icon @click="editContact(provider)">
                                                <v-icon color="primary">edit</v-icon>
                                            </v-btn>
                                        </template>
                                        <span>Modifier l'email destinataire</span>
                                    </v-tooltip>

                                </td>
                            </tr>
                        </tbody>
                    </v-simple-table>
                </v-expansion-panel-content>
            </v-expansion-panel>

            <v-expansion-panel v-if="emailsValid.length">
                <v-expansion-panel-header>
                    <div class="table-title">
                        <h3>E-mails valides <div class="badge bg-success text-white">{{
                                emailsValid.length
                        }}</div>
                        </h3>
                    </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                    <v-simple-table class="border" fixed-header height="50vh">
                        <thead>
                            <tr>
                                <th class="text-left">Nom</th>
                                <th class="text-left">Catégorie</th>
                                <th class="text-left">Destinataire</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="provider in emailsValid" :key="provider.id">
                                <td>{{ provider.name }}</td>
                                <td>{{ provider.category }}</td>
                                <td>
                                    <span v-if="provider.email !== null && aspect !== 'business'">
                                        {{ provider.email }}
                                    </span>
                                    <span v-else-if="provider.business_email !== null && aspect === 'business'">
                                        {{ provider.business_email }}
                                    </span>
                                </td>
                            </tr>
                        </tbody>
                    </v-simple-table>
                </v-expansion-panel-content>
            </v-expansion-panel>
        </v-expansion-panels>

        <div class="text-right mb-5 mt-5">
            <v-btn v-if="providers.length" class="default-button" @click="setCurrentStep(parseInt(currentStep) + 1)">Passer à l'étape suivante
            </v-btn>
        </div>

        <update-receiver-modale :edit-contact-modal="editModal" :selected-contact="selectedContact"
            :selected-provider="currentProvider">
        </update-receiver-modale>
    </div>
</template>

<script>
import { mapMutations, mapState } from "vuex"
import UpdateReceiverModale from "../../../provider/UpdateReceiverModale"
import * as EmailValidator from "email-validator"

export default {
    name: "Verification",
    components: { UpdateReceiverModale },
    props: ['isRevival', 'aspect'],
    data() {
        return {
            panel: [0],
            currentProvider: null,
            editModal: false,
            selectedContact: null
        }
    },
    methods: {
        ...mapMutations('createCmaj', ['setCurrentStep', 'setProviderByIndex', 'setEmailsValid', 'setEmailsWrong', 'setAlreadyInCampaign']),
        editContact(provider) {
            this.currentProvider = provider
            this.selectedContact = provider.contact !== undefined ? provider.contact : null
            this.editModal = true
        },
        updateProvider(provider) {
            this.providers.forEach((_provider, index) => {
                if (provider.id === _provider.id) {
                    let p = {
                        id: provider.id,
                        email: provider.contact.email,
                        category: provider.last_version.category.label,
                        commune: provider.last_version.localisation.commune.name,
                        name: provider.last_version.name
                    }

                    this.setProviderByIndex([index, p])
                    this.setEmailLists()
                }
            })
        },
        setEmailLists() {
            let emailsValid = []
            let emailsWrong = []

            this.providers.forEach(provider => {
                if(!this.isRevival || (this.isRevival && this.aspect !== 'business')) {
                    if (provider.contact === null) {
                        provider.error = 'Email non renseigné'
                        emailsWrong.push(provider)
                    } else if (!EmailValidator.validate(provider.email)) {
                        provider.error = 'Mauvais format d\'email'
                        emailsWrong.push(provider)
                    } else {
                        emailsValid.push(provider)
                    }
                } else {
                    if (provider.business_email === null) {
                        provider.error = 'Email non renseigné'
                        emailsWrong.push(provider)
                    } else if (!EmailValidator.validate(provider.business_email)) {
                        provider.error = 'Mauvais format d\'email'
                        emailsWrong.push(provider)
                    } else {
                        emailsValid.push(provider)
                    }
                }

            })

            this.setEmailsValid(emailsValid)
            this.setEmailsWrong(emailsWrong)
        },
        setAlreadyInCampaignList() {
          let alreadyInCampaign = []

          this.providers.forEach(provider => {
            if(provider.already_in_cmaj) {
              alreadyInCampaign.push(provider)
            }
          })

          this.setAlreadyInCampaign(alreadyInCampaign)
        }
    },
    computed: {
        ...mapState('createCmaj', ['emailsValid', 'emailsWrong', 'currentStep', 'providers', 'selectedApidaeSelection', 'alreadyInCampaign']),
    },
    watch: {
        providers() {
            this.setEmailLists()
            this.setAlreadyInCampaignList()
        }
    },
    created() {
        this.$global.$on('close-update-modal', () => {
            this.editModal = false
        })

        this.$global.$on('load-providers', (provider) => {
            this.updateProvider(provider)
        })
    },
    beforeDestroy() {
        this.$global.$off('close-update-modal')
        this.$global.$off('load-providers')
    }
}
</script>
